import { render, staticRenderFns } from "./emrProvider.vue?vue&type=template&id=6072e020"
import script from "./emrProvider.vue?vue&type=script&lang=js"
export * from "./emrProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports